import { FC, useState } from "react";
import uniqid from "uniqid";
import styles from "./styles.module.scss";
import { StaticImageData } from "next/image";
import classNames from "classnames";

export interface Step {
  title: string;
  text: string;
  image: StaticImageData | string;
}
export interface StepsPops {
  steps: Step[];
}

export const Steps: FC<StepsPops> = ({ steps }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);

  // const handleClickStep = (id: number) => () => {
  //   setCurrentStepIndex(id);
  // };

  return (
    <div className={styles.steps_container}>
      <div className={styles.number_container}>
        {steps.map((_, index) => (
          <span
            key={uniqid()}
            // className={classNames(styles.step_num)}
            // onClick={handleClickStep(index)}
          >
           {steps[index] && (
        <div className={styles.texts}>
          <div className={styles.left}>
            <h3>{steps[index].title}</h3>
            <div
              className={styles.text_container}
              dangerouslySetInnerHTML={{
                __html: steps[index].text,
              }}
            ></div>
          </div>
          
        </div>
      )}
          </span>
        ))}
      </div>
      
    </div>
  );
};
